// @ts-check
import { nanoid } from 'nanoid';

// A search session spans one search term, and the several filter-refined contexts a user
// moves through while keeping that term belong to it. Re-running the same term — a
// re-submit, or coming back to the results page — resumes the session rather than opening
// one, so its page view and clicks stay joinable. This is what separates query
// reformulation from filter refinement in the search metrics.
class SearchSessionIdManager {
  constructor() {
    /** @type {string | null} */
    this.sessionId = null;
    /** @type {string | null} */
    this.term = null;
  }

  /**
   * An empty term (clearing the input, leaving the search page) leaves the session
   * standing, so returning to the same results resumes it.
   *
   * @param {string} term
   */
  resolveSessionId(term) {
    if (term && term !== this.term) {
      this.sessionId = nanoid();
      this.term = term;
    }

    return this.sessionId;
  }
}

export default new SearchSessionIdManager();
